import React from 'react'
import { Copy, Box } from '@elparking/components'
import PropTypes from 'prop-types'

const ContractExtraInfo = ({ items }) => items
    ? <Box padding='1em' backgroundColor='accent10'>
        <Box as='ul' >
            {items.map(({ title, value }, index) =>
                <Box as='li' key={`footer_${index}`} mt={index !== 0 ? '1em' : '0'}>
                    {title && <Copy fontWeight='bold' fontSize='xSmall' padding='0'>{`· ${title}`}</Copy>}
                    <Copy fontWeight='regular' padding='0 0 0 9px' fontSize='xSmall'>{value}</Copy>
                </Box>
        )}
        </Box>
    </Box>
    : null

ContractExtraInfo.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
    })),
}

export default ContractExtraInfo
